const CustomerLayout = () => import(/* webpackChunkName: "customer" */'@/components/customer/CustomerLayout')
const CustomerList = () => import(/* webpackChunkName: "customer" */'@/components/customer/CustomerList')
const CustomerDetail = () => import(/* webpackChunkName: "customer" */'@/components/customer/CustomerDetail')
const IntegralList = () => import(/* webpackChunkName: "customer" */'@/components/customer/IntegralList')
const IntegralDetail = () => import(/* webpackChunkName: "customer" */'@/components/customer/IntegralDetail')
const VipSetting = () => import(/* webpackChunkName: "customer" */'@/components/customer/VipSetting')
export default {
  // name: 'customerLayout',
  path: 'customer',
  component: CustomerLayout,
  children: [
    {
      name: 'customerList',
      path: 'list',
      component: CustomerList,
      meta: {
        module: 'customer',
        keepAlive: true,
        isOutside: false, // 是不是从tab切换进入
      },
    },
    {
      name: 'vipSetting',
      path: 'vip',
      component: VipSetting,
      meta: {
        module: 'customer',
        keepAlive: true,
      },
    },
    {
      name: 'integralList',
      path: 'integralList',
      component: IntegralList,
      meta: {
        module: 'customer',
        keepAlive: true,
      },
    },
    {
      name: 'integralDetail',
      path: 'integralList/integralDetail',
      component: IntegralDetail,
      meta: {
        module: 'customer',
        keepAlive: true,
      },
    },
    {
      name: 'customerDetail',
      path: 'list/detail',
      component: CustomerDetail,
      meta: {
        module: 'customer',
        isSlibing: true,
      },
    },
    {
      path: '/',
      redirect: {name: 'customerList'},
    },
  ],
}



// WEBPACK FOOTER //
// ./src/router/customer.js